<form [formGroup]="form">
  <div
    class="header h-[55px] flex justify-start items-center pl-[50px] mb-[23px] bg-[#DEE2E6]"
  >
    <p class="!m-0">Request for Quotation (RFQ)</p>
    <p
      class="text-[#] !mt-[10px] text-[14px] font-semibold bg-white rounded-full !ml-[15px] px-[13px] !h-[24px] flex items-center justify-center"
    >
      Required Documentation
    </p>
  </div>
  <p class="subTitle pl-[28px] pb-[14px]">Technical Submission:</p>
  <div class="!px-[30px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-2">
    <span class="label"> Technical Proposal</span>
    <app-rich-textEditor
      (contentChange)="setTechnicalProposal($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('technical_proposal_control')?.value"
    ></app-rich-textEditor>

    <span class="label"> Project Programme</span>
    <app-rich-textEditor
      (contentChange)="setProjectProgramme($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('project_programme_control')?.value"
    ></app-rich-textEditor>
    <span class="label"> CVs of Key Personnel</span>
    <div class="flex items-center justify-start">
      <button
        type="button"
        class="attach_document px-2 py-[0.2rem] focus:outline-none flex justify-start items-center"
        (click)="fileInputDocument.click()"
      >
        <span class="text-[0.7rem]"> Attach Document </span>
        <img
          class="rounded-full ml-[4px]"
          src="assets/icons/document.svg"
          alt="document icon"
        />
      </button>
      <input
        type="file"
        #fileInputDocument
        (change)="onFileUpload($event, 'cv_of_key_personal_file_control')"
        multiple
        hidden
      />
      <img
        (click)="fileInputDocument.click()"
        class="rounded-full ml-[8px] w-[18px] cursor-pointer"
        src="assets/images/add_icon.png"
        alt="add icon"
      />
    </div>

    <!-- Old attachment -->
    <div
      class="flex flex-col"
      *ngFor="
        let oldCvOfKeyPersonalFile of oldCvOfKeyPersonalFiles;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              src="assets/icons/Image.svg
                "
              [src]="getFileIcon(oldCvOfKeyPersonalFile)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ oldCvOfKeyPersonalFile?.title }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="
            removeOldFile(
              i,
              oldCvOfKeyPersonalFile?.id,
              'cv_of_key_personal_file_control'
            )
          "
        />
      </div>
    </div>

    <!-- New attachment -->
    <div
      class="flex flex-col"
      *ngFor="
        let fileControl of cv_of_key_personal_file_control.controls;
        let i = index
      "
    >
      <div class="flex items-start mt-[11px]">
        <div class="flex justify-start items-center">
          <div
            class="relative ml-[5px] w-[2rem] h-[2rem] border border-gray-300 rounded-md overflow-hidden"
          >
            <!-- Check if the uploaded file is an image -->
            <img
              [src]="getFileIcon(fileControl.value)"
              alt="File Preview"
              class="object-cover w-auto h-[100%] cursor-pointer"
            />
          </div>
        </div>

        <!-- Display File Name -->
        <span
          style="
            color: black;
            text-align: left;
            font-size: 18px;
            white-space: nowrap;
            text-overflow: ellipsis;
            display: inline-block;
            overflow: visible;
            margin-left: 10px;
            margin-top: 5px;
          "
        >
          {{ fileControl.value.name }}
        </span>

        <!-- Remove File Button -->
        <img
          src="assets/icons/trash.svg"
          alt="trash"
          class="object-cover w-auto cursor-pointer ml-[8px] mt-[8px]"
          (click)="removeFile(i, 'cv_of_key_personal_file_control')"
        />
      </div>
    </div>

    <span class="label mt-[14px]"> Relevant Experience</span>
    <span class="sub_label"> Relevant Experience 1</span>
    <div class="flex justify-between items-center w-[100%] gap-16">
      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Client Name:  </mat-label>
          <input
            matInput
            type="text"
            formControlName="client_name_control1"
            placeholder="Client Name"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('client_name_control1').invalid &&
            form.get('client_name_control1').touched
          "
          class=""
        >
          <span style="color: red">Client name is required</span>
        </div>
      </div>

      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Location </mat-label>
          <input
            matInput
            type="text"
            formControlName="location_control1"
            placeholder="Location "
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('location_control1').invalid &&
            form.get('location_control1').touched
          "
          class=""
        >
          <span style="color: red">Location is required</span>
        </div>
      </div>
    </div>
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Project Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="project_description_control1"
          placeholder="Project Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('project_description_control1').invalid &&
          form.get('project_description_control1').touched
        "
      >
        <span style="color: red">Project description is required</span>
      </div>
    </div>

    <span class="sub_label !mt-[53px]"> Relevant Experience 2</span>
    <div class="flex justify-between items-center w-[100%] gap-16">
      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Client Name:  </mat-label>
          <input
            matInput
            type="text"
            formControlName="client_name_control2"
            placeholder="Client Name"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('client_name_control2').invalid &&
            form.get('client_name_control2').touched
          "
          class=""
        >
          <span style="color: red">Client name is required</span>
        </div>
      </div>

      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Location </mat-label>
          <input
            matInput
            type="text"
            formControlName="location_control2"
            placeholder="Location "
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('location_control2').invalid &&
            form.get('location_control2').touched
          "
          class=""
        >
          <span style="color: red">Location is required</span>
        </div>
      </div>
    </div>
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Project Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="project_description_control2"
          placeholder="Project Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('project_description_control2').invalid &&
          form.get('project_description_control2').touched
        "
      >
        <span style="color: red">Project description is required</span>
      </div>
    </div>

    <span class="sub_label !mt-[53px]"> Relevant Experience 3</span>
    <div class="flex justify-between items-center w-[100%] gap-16">
      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Client Name:  </mat-label>
          <input
            matInput
            type="text"
            formControlName="client_name_control3"
            placeholder="Client Name"
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('client_name_control3').invalid &&
            form.get('client_name_control3').touched
          "
          class=""
        >
          <span style="color: red">Client name is required</span>
        </div>
      </div>

      <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Location </mat-label>
          <input
            matInput
            type="text"
            formControlName="location_control3"
            placeholder="Location "
          />
        </mat-form-field>
        <div
          *ngIf="
            form.get('location_control3').invalid &&
            form.get('location_control3').touched
          "
          class=""
        >
          <span style="color: red">Location is required</span>
        </div>
      </div>
    </div>
    <div class="rounded p-0 !pb-0 !pt-0 w-[100%]">
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Project Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="project_description_control3"
          placeholder="Project Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('project_description_control3').invalid &&
          form.get('project_description_control3').touched
        "
      >
        <span style="color: red">Project description is required</span>
      </div>
    </div>

    <span class="label !mt-[53px]"> Health & Safety Management Plan</span>
    <app-rich-textEditor
      (contentChange)="setHealthSafety($event)"
      [resetEditor]="resetRichTextEditor"
      [richTextValue]="form.get('health_safety_control')?.value"
    ></app-rich-textEditor>
    <span class="label">Environmental Sustainability Plan</span>
    <div class="rounded !pl-0 !pb-0 !pt-0">
      <div
        class="long-section !pl-[21px] !p-10 !pb-0 !pt-0 items-center !w-[100%] !h-[100px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
      >
        <label> Do you have any environmental sustainability plan? </label>
        <mat-radio-group
          formControlName="environmental_sustainability_control"
          aria-label="environmental sustainability"
          class="flex gap-4 justify-end mr-8"
          [value]="form.get('environmental_sustainability_control')?.value"
        >
          <mat-radio-button [value]="1">Yes</mat-radio-button>
          <mat-radio-button [value]="0">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <!-- Show Description if 'Yes' is selected -->
    <div
      *ngIf="form.get('environmental_sustainability_control')?.value === 1"
      class="rounded p-0 !pb-0 !pt-0 w-[100%] mt-[8px]"
    >
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="environmental_sustainability_description"
          placeholder="Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('environmental_sustainability_description')?.invalid &&
          form.get('environmental_sustainability_description')?.touched
        "
      >
        <span style="color: red">Description is required</span>
      </div>
    </div>

    <!-- Technical Deviations -->
    <span class="label mt-[52px]">Technical Deviations/Clarifications</span>
    <div class="rounded !pl-0 !pb-0 !pt-0">
      <div
        class="long-section !pl-[21px] !p-10 !pb-0 !pt-0 items-center !w-[100%] !h-[100px] !mb-[0px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4"
      >
        <label> Do you have any technical deviations? </label>
        <mat-radio-group
          formControlName="technical_deviations_control"
          aria-label="technical deviations"
          class="flex gap-4 justify-end mr-8"
        >
          <mat-radio-button [value]="1">Yes</mat-radio-button>
          <mat-radio-button [value]="0">No</mat-radio-button>
        </mat-radio-group>
      </div>
    </div>

    <!-- Show Description if 'Yes' is selected -->
    <div
      *ngIf="form.get('technical_deviations_control')?.value === 1"
      class="rounded p-0 !pb-0 !pt-0 w-[100%] mt-[8px]"
    >
      <mat-form-field class="!w-[100%]" appearance="outline">
        <mat-label>Description</mat-label>
        <textarea
          matInput
          rows="4"
          formControlName="technical_deviations_description"
          placeholder="Description"
        ></textarea>
      </mat-form-field>
      <div
        *ngIf="
          form.get('technical_deviations_description')?.invalid &&
          form.get('technical_deviations_description')?.touched
        "
      >
        <span style="color: red">Description is required</span>
      </div>
    </div>
  </div>

  <div
    class="!pr-[32px] !mb-[30px] !mt-[93px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="handleBack()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px] !mr-[9px]"
        (click)="moveToNextStep('submit')"
      >
        Next
      </button>
      <button
        class="!h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px] !px-[9px]"
        (click)="moveToNextStep('commercial')"
      >
        Commercial Submission
      </button>
    </div>
  </div>
</form>
